Converia.Core.module('Converia.Core.DownloadList', function () {
    var fileList = [];
    var DownloadList = function (fileListConfig) {
        fileList = fileListConfig;
    };

    DownloadList.prototype.startDownload = function () {
        for (var i = 0, len = fileList.length; i < len; i++) {
            var url = fileList[i];
            var popup = window.open(url);

            if (!popup) {
                throw "Lance_Core_Begui_popup_blocked";
            }
        }
    };

    return DownloadList;
});